var $be28e2b7955b1a7d$exports = {};
$be28e2b7955b1a7d$exports = {
    "clear": `\u{418}\u{437}\u{447}\u{438}\u{441}\u{442}\u{438}`,
    "invalid": `(\u{43D}\u{435}\u{432}\u{430}\u{43B}\u{438}\u{434}\u{435}\u{43D})`,
    "loading": `\u{417}\u{430}\u{440}\u{435}\u{436}\u{434}\u{430}\u{43D}\u{435}...`,
    "noResults": `\u{41D}\u{44F}\u{43C}\u{430} \u{440}\u{435}\u{437}\u{443}\u{43B}\u{442}\u{430}\u{442}\u{438}`,
    "valid": `(\u{432}\u{430}\u{43B}\u{438}\u{434}\u{43D}\u{43E})`
};


export {$be28e2b7955b1a7d$exports as default};
//# sourceMappingURL=bg-BG.mjs.map
